module.exports = __webpack_public_path__ + "static/media/access_229.6ac29abe.ico";